import React, { useEffect, useState, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { after } from "lodash";
import _ from "lodash";
import moment from "moment";
import groupBy, { concat } from "lodash";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";

function SectorPerformanceChart() {
  const [sectorAllocation, setSectorAllocation] = useState(null);
  const [setDate, setSetDate] = useState(90);
  const [currentPage, setCurrentPage] = useState(90);
  const selectedClient = Cookies.get("client")
  useEffect(() => {
    FetchDataTypes("PortfolioSectorPerformanceDetails", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorAllocation(response.slice(0, setDate));
      });
    setCurrentPage(setDate);
  }, [setDate]);
  const newData = _.groupBy(sectorAllocation, "sectorName");

  function monthsData() {
    // if (newData && Object.keys(newData).length > 0) {
    //   let months = getYearMonths();
    //   return months;
    // }
    for (let key in newData) {
      const filtereddata = newData[key].filter((e) => e.perfDate);

      const updatedDate = filtereddata.map((e) =>
        new Date(e.perfDate).toLocaleDateString()
      );

      return updatedDate;
    }
  }

  let pushData = function () {
    const series = [];
    for (let key in newData) {
      const filtereddata = newData[key].filter((e) => e.perfDate);

      const data = filtereddata.map((e) => Number(e.mtdGross));

      series.push({
        showInLegend: false,
        name: key,
        type: "spline",
        data,
      });
    }

    return series;
  };
  const chartComponent = useRef(null);

  const handleResize = () => {
    const chart = chartComponent.current?.chart;
    if (chart) {
      const legendArea = document.querySelector(".legendArea");
      legendArea.innerHTML = "";

      chart.series.forEach((item, index) => {
        const list = document.createElement("li");
        const labelText = document.createElement("label");
        const myButton = document.createElement("input");

        myButton.type = "checkbox";

        myButton.textContent = item.name;
        labelText.style.color = item.color;

        if (myButton) {
          myButton.addEventListener("click", () => {
            item.setVisible(!item.visible);
          });

          labelText.append(item.name);
          list.appendChild(myButton);

          list.append(labelText);

          legendArea.append(list);
        }
      });
      chart.reflow();
    }
  };
  
  let highchartsCallback = function (chart) {
    const legendArea = document.querySelector(".legendArea");
    legendArea.innerHTML = "";
    chart.series.forEach((item, index) => {
      const list = document.createElement("li");
      const labelText = document.createElement("label");
      const myButton = document.createElement("input");

      myButton.type = "checkbox";

      myButton.textContent = item.name;
      labelText.style.color = item.color;

      if (myButton) {
        myButton.addEventListener("click", () => {
          item.setVisible(!item.visible);
        });

        labelText.append(item.name);
        list.appendChild(myButton);

        list.append(labelText);

        legendArea.append(list);
      }
    });
  };
  const Newoptions = {
    title: {
      text: "",
    },

    subtitle: {
      text: "",
    },

    yAxis: {
      // min: 0,
      title: {
        text: "",
      },
      labels: {
        format: "{value}%",
        style: {
          color: "rgb(124,181,236)",
        },
      },
    },

    xAxis: {
      categories: monthsData(),
      type: "datetime",
    },

    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "middle",
    },

    plotOptions: {
      series: {
        lineWidth: 1,
        label: {
          connectorAllowed: false,
        },
      },
    },

    series: pushData(),

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 400,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <div className="float-end text-end me-md-3 inline-flex">
        <div className="float-end">
          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-end Portfolio_chat">
              <li
                className={
                  (currentPage !== 30 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(30)}
              >
                <span className="page-link"> MTD</span>
              </li>
              <li
                className={
                  (currentPage !== 90 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(90)}
              >
                <span className="page-link"> 3M</span>
              </li>
              <li
                className={
                  (currentPage !== 180 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(180)}
              >
                <span className="page-link"> 6M</span>
              </li>
              <li
                className={
                  (currentPage !== 365 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(365)}
              >
                <span className="page-link"> YTD</span>
              </li>
              <li
                className={
                  (currentPage !== 400 ? "" : "active") +
                  " page-item cursor-pointer"
                }
                onClick={() => setSetDate(400)}
              >
                <span className="page-link"> 1Y</span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="sectorChart">
        <HighchartsReact
          highcharts={Highcharts}
          options={Newoptions}
          oneToOne={true}
          callback={highchartsCallback}
          ref={chartComponent}
          className="abc"
        />
        <div className="legendArea"></div>
      </div>
    </div>
  );
}

export default SectorPerformanceChart;
